import React, { useEffect, useState } from 'react';
import {
  SafeAreaView,
  ScrollView,
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
  ActivityIndicator,
  useWindowDimensions,
} from 'react-native';
import Modal from 'react-native-modal';
import { Icon } from 'react-native-elements';
import HTML from 'react-native-render-html';
import { get as _get } from 'lodash';

import Divider from '../../components/Divider';
import config from '../../lib/config';
import ZTImage from '../ZTImage';
import { trackScreenView } from '../../lib/analytics';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { selectPropertyManager } from '../../store/propertyManagerSlice';

export interface Props {
  onClose: () => void;
}

const PropertyManagerOverlay: React.FC<Props> = ({ onClose }) => {
  // const [isLoading, setIsLoading] = useState(true);
  // const [propertyManager, setPropertyManager] = useState({});
  const windowDimensions = useWindowDimensions();

  const { data: propertyManager, loading: isLoading } = useSelector(
    (state: RootState) => selectPropertyManager(state),
  );

  useEffect(() => {
    trackScreenView('Property Manager Details');
  }, []);

  return (
    <Modal
      isVisible
      backdropColor={'#000000'}
      backdropOpacity={0.5}
      hideModalContentWhileAnimating
      style={styles.overlay}
      onBackdropPress={onClose}
    >
      <View style={styles.topOverlay}>
        <View style={styles.closeButtonContainer}>
          <TouchableOpacity onPress={onClose}>
            <Icon
              tvParallaxProperties={null}
              activeOpacity={0.5}
              name={'close'}
              size={30}
              color={'#505050'}
            />
          </TouchableOpacity>
        </View>
      </View>
      <SafeAreaView>
        <ScrollView
          contentInsetAdjustmentBehavior="automatic"
          style={styles.scrollView}
        >
          {isLoading ? (
            <ActivityIndicator style={styles.loadingIndicator} />
          ) : (
            <>
              <ZTImage
                uri={_get(propertyManager, 'hero.url', '')}
                style={styles.mainImage}
              />
              <Divider />
              <View
                style={[styles.featureHeadingContainer, styles.sectionStart]}
              >
                <Text style={styles.featureHeading}>
                  {_get(propertyManager, 'name', '')}
                </Text>
                <HTML
                  source={{ html: _get(propertyManager, 'body', '') }}
                  contentWidth={windowDimensions.width}
                />
              </View>
            </>
          )}
        </ScrollView>
      </SafeAreaView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    margin: 0,
    marginTop: 40,
  },
  closeButtonContainer: {
    height: '100%',
    zIndex: 1000,
    flex: 1,
    alignContent: 'center',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginStart: 10,
  },
  topOverlay: {
    flex: 1,
    position: 'absolute',
    opacity: 0.5,
    borderTopStartRadius: 10,
    borderTopEndRadius: 10,
    overflow: 'hidden',
    right: 0,
    top: 0,
    width: '100%',
    height: 40,
    fontWeight: 'bold',
    zIndex: 1001,
    backgroundColor: '#ffffff',
    padding: 0,
    marginTop: 0,
  },
  scrollView: {
    backgroundColor: '#ffffff',
    marginHorizontal: 0,
    borderRadius: 10,
    minHeight: '100%',
  },
  loadingIndicator: {
    marginTop: 20,
  },
  featureHeadingContainer: {
    marginBottom: 5,
    marginHorizontal: 15,
  },
  sectionStart: {
    marginTop: 20,
    marginBottom: 20,
  },
  featureHeading: {
    fontSize: config.theme.headingFontSize,
    fontWeight: config.theme.headingFontWeight,
    color: config.theme.headingTextColor,
    marginBottom: 10,
  },
  mainImage: {
    height: 204,
    width: '100%',
  },
});

export default PropertyManagerOverlay;
